import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const About =()=>{
    const { t, i18n } = useTranslation();
    return(
        <section id="about">
                <div className='bg-exp'>
                    <div className='container'>
                    <div className='text-center text-light pb-5 about-titles poppins-medium'>{t('about.title')}</div>  
                    <div className='row d-flex justify-content-center'>
                        <div className="col-md-4 mb-4 mt-5">
                            <div className='text-center'>
                                <div className='position-relative'>
                                    <img src="../assets/images/teamwork.png" alt="First Image" className="img-fluid" />
                                </div>
                                <p className="mt-4 text-light poppins-regular" dangerouslySetInnerHTML={{ __html: t('about.teamwork') }}></p>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4 mt-5">
                            <div className='text-center'>
                                <div className='position-relative'>
                                    <img src="../assets/images/friends.png" alt="First Image" className="img-fluid" />
                                </div>
                                <p className="mt-2 text-light pt-4 poppins-regular">{t('about.friend')}</p>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4 mt-5">
                            <div className='text-center'>
                                <div className='position-relative'>
                                    <img src="../assets/images/badge.png" alt="First Image" className="img-fluid" />
                                </div>
                                <p className="mt-2 text-light pt-4 poppins-regular">{t('about.badge')}</p>
                            </div>
                        </div>
                    </div>
                    </div> 
                </div>
        </section>
    )

}

export default About;
